import AzureSuccessLogin from "../../components/azureSuccessLogin";
import { useParams } from "react-router-dom";

const AzureSuccessLoginPage = () => {
  let { token } = useParams();
  return <AzureSuccessLogin token={token}></AzureSuccessLogin>;
};

export default AzureSuccessLoginPage;
